import React from "react";

const Section = ({
  view,
  position,
  isCollapsed,
  weight,
  flexGrow: flexGrowOverride,
  toggleCollapse,
  children
}) => {

  let flexGrow = flexGrowOverride !== undefined ? flexGrowOverride : (position == "CENTER" ? weight : 0);
  let flexBasis = position != "CENTER" ? `calc(100% * ${weight} / 12)` : "auto";
  let minWidth = isCollapsed ? "2.5rem" : "17rem";
  if (isCollapsed) flexBasis = "2.75rem";

  return (
    <div
      key={view.name}
      className={
        `section-view position-relative section-${position.toLowerCase()} ` +
        `${isCollapsed ? "collapsed px-0" : ""}`
      }
      style={{
        flexGrow: flexGrow,
        flexBasis: flexBasis,
        minWidth: minWidth
      }}
    >
      {isCollapsed && (
        <div
          className="section-collapsed-container h-100 d-flex flex-column align-items-center justify-content-start pt-2 pt-md-4 cursor-pointer"
          onClick={() => toggleCollapse(view.name)}
        >
          <div className="mb-auto" />
          <div className="section-collapsed-title font-weight-bold mb-3 d-none d-sm-block">
            {view.label}
          </div>
          <div className="text-white mb-4">
            <i className={`${view.icon || "fas fa-layer-group"}`}></i>
          </div>
        </div>
      )}
      <div
        className="h-100 w-100 position-relative overflow-auto"
        style={isCollapsed ? {
          visibility: "hidden",
          position: "absolute",
          top: 0,
          left: 0,
          width: 0,
          height: 0,
          overflow: "hidden"
        } : {}}
      >
        {
          !isCollapsed && view.settings?.type === "COLLAPSED" &&
          <div
            className="section-collapse-btn btn btn-sm position-absolute d-flex align-items-center justify-content-center text-white mt-2"
            onClick={() => toggleCollapse(view.name)}
          >
            {position === "RIGHT" || window.innerWidth < 768 ?
              <i className="fas fa-chevron-right"></i> :
              <i className="fas fa-chevron-left"></i>}
          </div>
        }
        {children}
      </div>
    </div>
  );
};

export default Section;
